import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';

import { styles } from './index.styles';

interface ErrorDialogProps {
  errorMessage: string | ReactNode;
  severity?: 'notice' | 'error' | '';
  onClose: () => void;
  isOpen: boolean;
}

const ErrorDialog: FC<ErrorDialogProps> = ({
  errorMessage,
  severity = '',
  onClose,
  isOpen,
}) => {
  const { t } = useTranslation('common');

  return (
    <Dialog
      className="ErrorDialog-root"
      fullWidth
      onClose={onClose}
      open={isOpen}
    >
      <DialogTitle
        alignItems="center"
        display="flex"
        justifyContent="space-between"
      >
        {t('error')}

        <IconButton data-test-id="dialog-close-button" onClick={onClose}>
          <CloseIcon color="primary" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography color={severity} sx={styles.errorMessage}>
          {errorMessage}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorDialog;
